"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarService = void 0;
const typedi_1 = require("typedi");
const lit_html_1 = require("lit-html");
/**
 * Конртроллер sidebar
 */
let SidebarService = class SidebarService {
    constructor() {
        /**
         * Шаблоны
         */
        this.templates = new Map();
        /**
         * Классы sidebar
         */
        this.containerClasses = 'art-sidebar';
        /**
         * Sidebar инициализировано
         */
        this.inited = false;
        /**
         * DOM эелемент sidebar
         */
        this.sidebarElement = null;
    }
    /**
     * Регистрирует шаблон
     */
    registerTemplate(name, templateGenerator) {
        this.templates.set(name, templateGenerator);
    }
    /**
     * Возвращает контейнер модального окна
     */
    getContainer() {
        const sidebar = document.querySelector(`.${this.containerClasses}`);
        if (sidebar)
            return sidebar;
        return null;
    }
    /**
     * Инициализирует контейнер
     */
    initContainer() {
        return __awaiter(this, void 0, void 0, function* () {
            const container = document.createElement('div');
            container.classList.add(this.containerClasses);
            container.addEventListener('click', (e) => {
                const el = e.target;
                if (el.classList.contains('art-sidebar'))
                    this.close();
            });
            const closeBtn = document.createElement('button');
            closeBtn.classList.add('btn-close');
            closeBtn.type = 'button';
            closeBtn.addEventListener('click', (e) => {
                this.close();
            });
            container.append(closeBtn);
            document.body.append(container);
            return container;
        });
    }
    /**
     * Открывает sidebar
     */
    open(name, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const templateGenerator = this.templates.get(name);
            if (!templateGenerator)
                return;
            const isOpened = !!this.getContainer();
            if (isOpened) {
                yield this.close();
            }
            const container = yield this.initContainer();
            const template = templateGenerator(params);
            this.inited = true;
            (0, lit_html_1.render)(template, container);
        });
    }
    /**
     * Закрывает окно
     */
    close() {
        return new Promise((resolve) => {
            const container = this.getContainer();
            if (container) {
                container.remove();
                this.sidebarElement = null;
            }
            resolve();
        });
    }
};
SidebarService = __decorate([
    (0, typedi_1.Service)()
], SidebarService);
exports.SidebarService = SidebarService;
